import Button from '@/components/UI/Button';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';

interface OtherIncomeProps {
  onNext: () => void;
  onPrevious: () => void;
}

export const OtherIncome = ({ onNext, onPrevious }: OtherIncomeProps) => {
  return (
    <div className='p-6 space-y-6 sm:rounded-r-md sm:overflow-hidden'>
      <div>
        <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Other Income (if applicable)</h3>
        <p className='mt-2 text-sm text-gray-600'>Upload documents for any additional income sources that apply to your situation.</p>
      </div>

      <div className='space-y-6'>
        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Pension or retirement distribution statement or award letter</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload pension or retirement income documentation</p>
            </div>
          </div>
          <HookFileInput
            name='otherIncome.pensionDocuments'
            label='Pension Documents'
            multiple
            customClassName='mt-4'
            placeholder='Choose pension document files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Social Security (SSA or SSDI) current-year award letter</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload your current year Social Security award letter</p>
            </div>
          </div>
          <HookFileInput
            name='otherIncome.socialSecurityDocuments'
            label='Social Security Documents'
            multiple
            customClassName='mt-4'
            placeholder='Choose Social Security document files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Supplemental Security Income (SSI) current-year award letter</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload your current year SSI award letter</p>
            </div>
          </div>
          <HookFileInput
            name='otherIncome.ssiDocuments'
            label='SSI Documents'
            multiple
            customClassName='mt-4'
            placeholder='Choose SSI document files or drag and drop'
          />
        </div>

        <div className='bg-white p-6 rounded-lg border border-gray-200'>
          <div className='flex items-start space-x-3 mb-4'>
            <div className='shrink-0'>
              <input
                type='checkbox'
                className='h-4 w-4 text-primaryColor-normal focus:ring-primaryColor-normal border-gray-300 rounded'
                disabled
              />
            </div>
            <div className='min-w-0 flex-1'>
              <h4 className='text-sm font-medium text-gray-900'>Annuity, VA benefits, or other recurring income documentation</h4>
              <p className='text-sm text-gray-500 mt-1'>Upload documentation for any other sources of recurring income</p>
            </div>
          </div>
          <HookFileInput
            name='otherIncome.otherIncomeDocuments'
            label='Other Income Documents'
            multiple
            customClassName='mt-4'
            placeholder='Choose other income document files or drag and drop'
          />
        </div>
      </div>

      <div className='flex gap-4 justify-end mt-8'>
        <Button label='Previous' btnStyle='neutral' type='button' onClick={onPrevious} />
        <Button label='Next' btnStyle='primary' type='submit' />
      </div>
    </div>
  );
};
